<template>
	<v-container>
		<v-row justify="start">
			<v-col cols="12" md="6" lg="3">
				<autocomplete :set-loading="setLoading" />
			</v-col>
			<v-col cols="12">
				<content-audit :loading="loading" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Audit',
	components: {
		Autocomplete: () => import('@/components/audits/AutocompletePerson'),
		ContentAudit: () => import('@/components/audits/Content'),
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		setLoading(value) {
			this.loading = value;
		},
	},
};
</script>
